<template lang="pug">
  div
    header-component
    section.section.main-content
      .container
        .columns
          .column
            h4.title-dashboard Programa
            h3.subtitle-dashboard Dashboard
          a.button-quotation-wrapper(
            v-if="!showButtonNew"
            @click="showPage('new')",
            type="is-primary"
            )
            .button-quotation Nueva Cotización
        b-tabs(:animated="false", :destroy-on-hide="true" @input="changeTab")
          b-tab-item(value="team" v-if="showGeneralBag")
            template(slot="header")
              b-icon(icon="account-group", size="is-small")
              span.tab-title Bolsa general
            data-grid-programs(filter="team")
          b-tab-item(v-if="showMyPendings")
            template(slot="header")
              b-icon(icon="account-group", size="is-small")
              span.tab-title Pendientes TEC
            data-grid-programs(filter="team-pending")
          b-tab-item(value="inbox")
            template( slot="header")
              b-icon(icon="inbox", size="is-small")
              span.tab-title Mi bandeja
            data-grid-programs
          b-tab-item(v-if="showUnquotedInbox" value="unquoted")
            template(slot="header")
              b-icon(icon="clock", size="is-small")
              span.tab-title En curso
            data-grid-programs(filter="unquoted")
          b-tab-item(v-if="showFinishedInbox" value="finish")
            template(slot="header")
              b-icon(icon="check-all", size="is-small")
              span.tab-title Finales
            data-grid-programs(filter="finish")
  </template>

<script>
import HeaderComponent from "../components/_layouts/Header.vue";
import DataGridPrograms from "@/components/DataGridPrograms.vue";
import {
  isRoleOperative,
  isExecutiveTeamSupervisor,
  isExecutiveNationalSupervisor,
  isRoleTeamSupervisor,
  isRoleAdministrator,
  isTechnicalOperative,
  isEmission,
  isTechnical,
  isExecutiveManager
} from "@/mixins/user";
import { getProductsByCompany } from '../services/services';
import { companies } from '../globals';
import store from '../store';
export default {
  name: "DashboardPrograms",
  components: {
    HeaderComponent,
    DataGridPrograms,
  },
  data() {
    return {
      products: [],
      filtersSelected: {
        productsSelected: [],
        brokersSelected: [],
        datesCreation: [],
        datesUpdates: [],
        metaStatesSelected: [],
        supervisorsSelected: [],
        operativesSelected: [],
      }
    }
  },
  computed: {
    showGeneralBag() {
      return (
        isRoleAdministrator() ||
        isRoleTeamSupervisor() ||
        isTechnicalOperative()
      );
    },
    showButtonNew() {
      return isExecutiveManager() || isEmission() || isTechnical()
    },
    executiveSupervisor() {
      return isExecutiveTeamSupervisor()
    },
    executiveNational() {
      return isExecutiveNationalSupervisor()
    },
    showUnquotedInbox() {
      return !isEmission();
    },
    showFinishedInbox() {
      return !isEmission();
    },
    showMyPendings() {
      return isTechnical();
    },
  },
  mounted() {
    getProductsByCompany(companies.LPG).then((result) => {
      this.products = result.data
    })
    
  },
  methods: {
    showPage(page){
      page == 'dashboard' || page == 'dashboard-programs'?
      this.$router.push('/'+page) :
      this.$router.push('/quotation/'+page);
    },
    changeTab(string) {
      this.filterClean()
    },
    filterClean() {
     
    }
  }
};
</script>

<style lang="scss">
  .loading {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 1em;
  }
  .tab-title {
    font-weight: bold;
    font-size: 14px;
  }
  .tab-content {
    background-color: #fdfdfd;
    padding: 1rem 1rem 0 !important;
  }

  .dashboard-table__row {
    cursor: pointer;
    p.date {
      font-size: 10px;
    }
    &.unread {
      background: #fff;
    }
    &:hover {
      background: #fbfbfb;
    }
  }

  .title-dashboard{
    margin-bottom: 0;
  }

  .subtitle-dashboard{
    font-size: 20px;
    line-height: 26px;
    font-weight: 400;
  }

  .title-dashboard{
    font-size: 32px;
    line-height: 38px;
    font-weight: 700;
    margin: 0;
    color: #272B30;
  }

  .modal-background{
    background-color: rgba(0, 0, 0, 0.25);
  }

  .modal-content{
    max-width: 1156px !important;
    width: 100% !important;
  }

  .modal-close{
    display: none;
  }

  .button-quotation-wrapper {
    display: flex;
    align-items: center;
  }

  .button-quotation{
    display: inline-flex;
    height: 40px;
    min-width: 80px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 100px;
    background: #FF6D46;
    color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(64, 64, 64, 0.30);
  }

</style>